export enum AuthKey {
  SIGNUP = 'signup',
  SESSION = 'session',
}
